exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".top_tools_div[data-v-63121718]{width:100%;min-height:80px;position:fixed;top:0;z-index:1999;padding-bottom:5px}", ""]);

// exports
